import React from 'react'
import { Link } from 'react-router-dom'
import { Tag, Tooltip, Typography } from 'antd'
import ContactButtons from './ContactButtons'
import { AttentionTag, ChannelTag, KindTag, StageTag, StatusTag, UpdatesTag } from './tags'
import { contactMessage, formatAge, formatDate, formatDateTime, money } from './utils'

// A row carries enough to act without opening it: who to ring, what the customer is being shown,
// whether the money is in, and how old the silence is. That is the difference between a worklist
// and a list.
/* eslint-disable react/display-name */
export const shipmentColumns = () => [
  {
    title: 'Number',
    key: 'number',
    render: (_, r) => (
      <div>
        <Typography.Text copyable strong>
          {r.number}
        </Typography.Text>
        <div style={{ marginTop: 4 }}>
          <KindTag kind={r.kind} roro={r.lineRoro} />
          <ChannelTag channel={r.channel} />
          {/* Only when they are OFF: on is the default for every shipment, so a tag on every row
              would be noise. */}
          <UpdatesTag shipment={r} />
          {/* The customer deleted it before paying. Staff still see it, and it explains why
              nobody is chasing this one. */}
          {r.hidden ? <Tag>Hidden by customer</Tag> : null}
        </div>
      </div>
    )
  },
  {
    title: 'Line',
    key: 'line',
    render: (_, r) => (
      <div>
        <div>{r.lineName || '—'}</div>
        {r.lineScac ? <div style={{ opacity: 0.65 }}>{r.lineScac}</div> : null}
      </div>
    )
  },
  {
    title: 'Customer',
    key: 'customer',
    render: (_, r) => <ContactButtons phone={r.phone} message={contactMessage(r)} />
  },
  {
    title: 'Stage',
    key: 'stage',
    render: (_, r) => (
      <div>
        <StageTag
          stage={r.stage}
          title={r.stageTitle}
          attention={r.attention}
          completion={r.completion}
        />
        <div style={{ marginTop: 4 }}>
          <StatusTag status={r.status} completion={r.completion} />
        </div>
      </div>
    )
  },
  {
    title: 'ETA',
    key: 'eta',
    render: (_, r) =>
      r.eta ? (
        <span>
          {formatDate(r.eta)}
          {r.etaEstimated ? <Tag style={{ marginLeft: 4 }}>est.</Tag> : null}
        </span>
      ) : (
        '—'
      )
  },
  {
    title: 'Paid',
    key: 'paid',
    render: (_, r) =>
      r.paid ? (
        money(r.amountPaid, r.currency)
      ) : (
        <span style={{ opacity: 0.65 }}>Unpaid</span>
      )
  },
  {
    title: 'Updated',
    key: 'updated',
    render: (_, r) => (
      <Tooltip
        title={`Last event ${formatDateTime(r.lastEventAt)} · Last checked ${formatDateTime(
          r.lastCheckedAt
        )}`}
      >
        <span>{`${formatAge(r.lastEventAt || r.updatedAt)} ago`}</span>
      </Tooltip>
    )
  },
  {
    title: 'Attention',
    key: 'attention',
    render: (_, r) => (
      <AttentionTag
        kind={r.attention}
        priority={r.attentionPriority}
        since={r.attentionSince}
      />
    )
  },
  {
    title: '',
    key: 'open',
    render: (_, r) => <Link to={`/tracking/shipments/${r.id}`}>Open</Link>
  }
]
/* eslint-enable react/display-name */

export default shipmentColumns
